import React, { useState, useEffect } from "react";
import { useLocation,Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import MenuIcon from "@mui/icons-material/Menu";
import { useNavigate } from "react-router-dom";
import { ExpandMore } from "@mui/icons-material";

const submenusConfig = {
  reports: [
    "/standards",
    "/csrd",
    "/Materiality",
    "/ReportingModules",
    "/GenerateReport",
    "/PreviewReport",
  ],
  company: [
    "/listofentities",
    "/company",
    "/listofbusinessunits",
    "/Businessunit",
    "/listsitelocations",
    "/sitelocation",
  ],
  settings: ["/listofusers", "/adduser"],
};

const includesAnyPath = (pathname, paths) => paths.some((path) => pathname.includes(path));

const SideNavigation = (props) => {
  let location = useLocation();
  const [open, setOpen] = useState(true);
  const { reportsMenu, companyMenu, settingsMenu } = Object.entries(submenusConfig).reduce(
    (acc, [key, value]) => {
      acc[`${key}Menu`] = includesAnyPath(location.pathname, value) ? "showMenu" : "";
      return acc;
    },
    {}
  );

  const toggleSidebar = () => {
    setOpen(!open);
    props.getOpen(!open);
    localStorage.setItem("sidebarOpen", JSON.stringify(!open));
  };

  // Function to toggle submenu
  const toggleSubMenu = (event) => {
    event.preventDefault();
    const listItem = event.currentTarget.parentElement;
    const allListItems = document.querySelectorAll(".nav-links > li");

    // Close all other dropdowns
    allListItems.forEach((item) => {
      if (item !== listItem && item.classList.contains("showMenu")) {
        item.classList.remove("showMenu");
      }
    });

    // Toggle the clicked dropdown
    listItem.classList.toggle("showMenu");
  };

  useEffect(() => {
    localStorage.setItem("sidebarOpen", JSON.stringify(open));
    const storedSidebarOpen = JSON.parse(localStorage.getItem("sidebarOpen"));
    console.log("UseEffect Call "+storedSidebarOpen);
  }, [open]);

  useEffect(() => {
    const storedSidebarOpen = JSON.parse(localStorage.getItem("sidebarOpen"));
    if (storedSidebarOpen !== null) {
      setOpen(storedSidebarOpen);
    }
  }, []);

  

  const sidebarClass = open ? "sidebar open" : "sidebar close";

  return (
    <div className={sidebarClass}>
      {/* Sidebar content */}
      {/* Logo */}
      {open && (
        <div style={{ marginLeft: "40px" }}>
        <a href="/home">
          <img src="assets/img/logo.png" alt="ecoPrism" className="logo-sidebar" />
        </a>
      </div>

      )}

      {/* Collapse icon (visible only when sidebar is expanded) */}
      {open && (
        <div className="sidenav-left-icon">
          <IconButton color="inherit" aria-label="toggle drawer" onClick={toggleSidebar} edge="end">
            <ChevronLeftIcon
              style={{
                color: "#407775",
                backgroundColor: "#EEF1F5",
                borderRadius: "9px 0 0 9px",
              }}
            />
          </IconButton>
        </div>
      )}

      {/* Menu icon (visible only when sidebar is collapsed) */}
      {!open && (
        <div className="sidenav-menu-icon">
          <IconButton color="inherit" aria-label="toggle drawer" onClick={toggleSidebar} edge="end">
            <MenuIcon style={{ color: "aliceblue", marginLeft: "10px" }} />
          </IconButton>
        </div>
      )}

<ul className="nav-links">
      {/* Dashboard */}
      <li>
        <Link
          to="/dashboard"
          className={`${
            location.pathname === "/dashboard" || location.pathname === "/scope2"
              ? open
                ? "icon-list-active"
                : "icon-list-collapse-active"
              : "main-menu-item"
          }`}
        >
          <div className={open ? "list-icon" : "list-icon-collapse"}>
            <img
              src={
                location.pathname === "/dashboard" || location.pathname === "/scope2"
                  ? "assets/img/sidebar/active/Dashboard.png"
                  : "assets/img/sidebar/Dashboard.png"
              }
              alt="Dashboard"
              className="sidebar-image"
            />
          </div>
          <span className="link_name">Dashboard</span>
        </Link>
        <ul className="sub-menu blank">
          <li>
            <Link className="link_name" to="/dashboard">
              Dashboard
            </Link>
          </li>
        </ul>
      </li>

      {/* Reports */}
      <li className={`reports-dropdown ${reportsMenu}`}>
        <div className="iocn-link" onClick={toggleSubMenu}>
          <Link to="#">
            <div className={open ? "list-icon" : "list-icon-collapse"}>
              <img
                src={
                  includesAnyPath(location.pathname, submenusConfig.reports)
                    ? "assets/img/sidebar/active/Reports.png"
                    : "assets/img/sidebar/Reports.png"
                }
                alt="Reports"
                className="sidebar-image"
              />
            </div>
            <span className="link_name">Reports</span>
          </Link>
          <ExpandMore className="chevron-down" />
        </div>
        <ul className="reports sub-menu submenu-list">
          <li className="submenu-header">
            <span className="link_name">Reports</span>
          </li>
          <li>
            <Link
              to="/standards"
              className={
                [
                  "/standards",
                  "/csrd",
                  "/Materiality",
                  "/ReportingModules",
                  "/GenerateReport",
                  "/PreviewReport",
                ].includes(location.pathname)
                  ? "icon-list-active-submenu submenu-item"
                  : "submenu-item main-menu-item"
              }
            >
              Standards & Frameworks
            </Link>
          </li>
        </ul>
      </li>

      {/* Green Button */}
      <li>
        <Link
          to="/comingsoon"
          className={`${
            location.pathname === "/comingsoon"
              ? open
                ? "icon-list-active"
                : "icon-list-collapse-active"
              : "main-menu-item"
          }`}
        >
          <div className={open ? "list-icon" : "list-icon-collapse"}>
            <img
              src={
                location.pathname === "/comingsoon"
                  ? "assets/img/sidebar/active/Greenbutton.png"
                  : "assets/img/sidebar/Green.png"
              }
              alt="Green Button"
              className="sidebar-image"
            />
          </div>
          <span className="link_name">Green Button</span>
        </Link>
        <ul className="sub-menu blank">
          <li>
            <Link className="link_name" to="/comingsoon">
              Green Button
            </Link>
          </li>
        </ul>
      </li>

      {/* Insights */}
      <li>
        <Link
          to="/insights"
          className={`${
            [
              "/insights",
              "/assessing-low-re",
              "/electricity-cost-evaluation",
              "/assessing-elec-usage",
            ].includes(location.pathname)
              ? open
                ? "icon-list-active"
                : "icon-list-collapse-active"
              : "main-menu-item"
          }`}
        >
          <div className={open ? "list-icon" : "list-icon-collapse"}>
            <img
              src={
                [
                  "/insights",
                  "/assessing-low-re",
                  "/electricity-cost-evaluation",
                  "/assessing-elec-usage",
                ].includes(location.pathname)
                  ? "assets/img/sidebar/active/Insights.png"
                  : "assets/img/sidebar/Insights.png"
              }
              alt="Insights"
              className="sidebar-image"
            />
          </div>
          <span className="link_name">Insights</span>
        </Link>
        <ul className="sub-menu blank">
          <li>
            <Link className="link_name" to="/insights">
              Insights
            </Link>
          </li>
        </ul>
      </li>

      {/* Configuration */}
      <li>
        <Link
          to="/allconfiguration"
          className={`${
            [
              "/allconfiguration",
              "/configuration",
              "/reporthistory",
            ].includes(location.pathname)
              ? open
                ? "icon-list-active"
                : "icon-list-collapse-active"
              : "main-menu-item"
          }`}
        >
          <div className={open ? "list-icon" : "list-icon-collapse"}>
            <img
              src={
                [
                  "/allconfiguration",
                  "/configuration",
                  "/reporthistory",
                ].includes(location.pathname)
                  ? "assets/img/sidebar/active/Configuration.png"
                  : "assets/img/sidebar/Configuration.png"
              }
              alt="Configuration"
              className="sidebar-image"
            />
          </div>
          <span className="link_name">Configuration</span>
        </Link>
        <ul className="sub-menu blank">
          <li>
            <Link className="link_name" to="/allconfiguration">
              Configuration
            </Link>
          </li>
        </ul>
      </li>

      {/* Company */}
      <li className={`company-dropdown ${companyMenu}`}>
        <div className="iocn-link" onClick={toggleSubMenu}>
          <Link to="#">
            <div className={open ? "list-icon" : "list-icon-collapse"}>
              <img
                src={
                  includesAnyPath(location.pathname, submenusConfig.company)
                    ? "assets/img/sidebar/active/Company.png"
                    : "assets/img/sidebar/Company.png"
                }
                alt="Company"
                className="sidebar-image"
              />
            </div>
            <span className="link_name">Company</span>
          </Link>
          <ExpandMore className="chevron-down" />
        </div>
        <ul className="company sub-menu submenu-list">
          <li className="submenu-header">
            <Link className="link_name" to="#">
              Company
            </Link>
          </li>
          <li>
            <Link
              to="/listofentities"
              className={
                location.pathname === "/listofentities" || location.pathname === "/company"
                  ? "icon-list-active-submenu submenu-item"
                  : "submenu-item main-menu-item"
              }
            >
              Legal Entities
            </Link>
          </li>
          <li>
            <Link
              to="/listofbusinessunits"
              className={
                location.pathname === "/listofbusinessunits" || location.pathname === "/Businessunit"
                  ? "icon-list-active-submenu submenu-item"
                  : "submenu-item main-menu-item"
              }
            >
              Business Units
            </Link>
          </li>
          <li>
            <Link
              to="/listsitelocations"
              className={
                location.pathname === "/listsitelocations" || location.pathname === "/sitelocation"
                  ? "icon-list-active-submenu submenu-item"
                  : "submenu-item main-menu-item"
              }
            >
              Site Locations
            </Link>
          </li>
        </ul>
      </li>

      {/* Settings */}
      <li className={`settings-dropdown ${settingsMenu}`}>
        <div className="iocn-link" onClick={toggleSubMenu}>
          <Link to="#">
            <div className={open ? "list-icon" : "list-icon-collapse"}>
              <img
                src={
                  includesAnyPath(location.pathname, submenusConfig.settings)
                    ? "assets/img/sidebar/active/Settings.png"
                    : "assets/img/sidebar/Settings.png"
                }
                alt="Settings"
                className="sidebar-image"
              />
            </div>
            <span className="link_name">Settings</span>
          </Link>
          <ExpandMore className="chevron-down" />
        </div>
        <ul className="settings sub-menu submenu-list">
          <li className="submenu-header">
            <span className="link_name">Settings</span>
          </li>
          <li>
            <Link
              to="/listofusers"
              className={
                location.pathname === "/listofusers" || location.pathname === "/adduser"
                  ? "icon-list-active-submenu submenu-item"
                  : "submenu-item main-menu-item active"
              }
            >
              User Management
            </Link>
          </li>
        </ul>
      </li>
    </ul>
      {/* Profile section */}
      <div className="profile-details">
        <div className="job">Powered by ecoPRISM</div>
      </div>
    </div>
  );
};

export default SideNavigation;
